import { render } from "./RaiseDisputeModal.vue?vue&type=template&id=4db4bbbe&scoped=true"
import script from "./RaiseDisputeModal.vue?vue&type=script&lang=js"
export * from "./RaiseDisputeModal.vue?vue&type=script&lang=js"

import "./RaiseDisputeModal.vue?vue&type=style&index=0&id=4db4bbbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db4bbbe"]])

export default __exports__